import { useEffect, useRef } from "react";
import useAuth from "../../hooks/useAuth";
import { baseURL, handleNotOkHttpResponse } from "../../utils/misc";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isSinglePageActive } from "../../utils/daynamicNavigation";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import Preloader from "../common/Preloader";
import { getFarmerFullName, getFullBuyerName, getUserFullName, isoToDate } from "../../utils/helpers";
import { getFarmerById } from "../../api/Farmer/getFarmerById";

function DocumentTable() {
    const { user } = useAuth();
    const [documents, setDocuments] = useState([]);
    const navigate = useNavigate();
    const [showPreloader, setShowPreloader] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const profileMenuItems = [
        {
            id: 1,
            name: "View",
            icon: "icon-eye1",
            onClick: (process) => {
                handleShowViewModal(process);
            },
        },
        {
            id: 2,
            name: "Edit",
            icon: "icon-edit1",
            routerPath: "/document/edit",
        },
        {
            id: 3,
            name: "Delete",
            icon: "icon-delete",
            onClick: (process) => {
                handleShowDeleteModal(process);
            },
            authType: 'admin',
        }
    ];

    // Define the path pattern for user profiles
    const $ = require("jquery");

    useEffect(() => {
        if (documents && documents.length > 0) {
            //Initialize DataTable when users are available
            $(document).ready(function () {
                const dataTable = $("#data-table").DataTable();

                // Destroy DataTable if it exists
                if (dataTable) {
                    dataTable.destroy();
                }

                $("#data-table").DataTable({
                    // Add any required DataTable options here
                    columnDefs: [
                        { width: "10%", targets: 0 },
                        { width: "12%", targets: 2 }
                    ]
                });
            });
        }
    }, [documents, $]);


    useEffect(() => {
        const fetchDocuments = async () => {
            if (!(user && user.user.token)) {
                navigate('/login');
            }
            setShowPreloader(true);
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${user.user.token}`,
                    }
                };
                const response = await fetch(`${baseURL}/documents`, requestOptions);
                if (!response.ok) {
                    throw new Error('Error fetching documents');
                }
                const data = await response.json();
                setDocuments(data);
            } catch (error) {
                toast.error("Error fetching documents.");
                console.error("Error fetching documents:", error);
            } finally {
                setShowPreloader(false);
            }
        };
        fetchDocuments();
    }, []);

    const handleShowViewModal = (record) => {
        setSelectedRecord(record);
        setShowViewModal(true);
    };

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedRecord(null);
    };

    const handleShowDeleteModal = (record) => {
        setSelectedRecord(record);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedRecord(null);
    };

    const handleRemoveDocument = async () => {
        if (!(user && user.user.token)) {
            navigate('/login');
        }

        setShowPreloader(true);
        try {
            if (!selectedRecord) {
                console.error('No selected Record');
                return;
            }

            const requestOptions = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                },
                redirect: "follow",
            };

            const response = await fetch(`${baseURL}/documents/${selectedRecord.id}`, requestOptions);
            if (response.ok) {
                toast.success("Document removed successfully");
                handleCloseDeleteModal();
                setShowPreloader(true);
                window.location.reload();
            } else {
                handleNotOkHttpResponse(response);
                return false;
            }
        } catch (error) {
            console.error("Error on removing Document:", error.message);
        } finally {
            setShowPreloader(false);
        }
    };


    return (
        <>
            <Preloader show={showPreloader} />
            <div className="main-container">
                <div className="row gutters">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="card-title">List of Documents</div>
                                <br />
                                <Link
                                    to={`/document/create`}
                                    className="btn btn-primary float-end"
                                >
                                    <i className="icon-add"></i> Add Document
                                </Link>
                            </div>
                            <div className="card-body pt-0">
                                <div className="row gutters">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="table-responsive">
                                            <table id="data-table" className="table custom-table">
                                                <thead className="thead-dark">
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>Date Of Issuance</th>
                                                        <th>Date Of Expiry</th>
                                                        <th>Document Name</th>
                                                        <th><div className="float-end">Actions</div></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {documents && documents.length > 0 ? documents.map((document, index) => (
                                                        <tr key={index}>
                                                            <td>{document.documentCode ? document.documentCode : '--'}</td>
                                                            <td>{isoToDate(document.dateOfIssuance)}</td>
                                                            <td>{isoToDate(document.dateOfExpiry)}</td>
                                                            <td>{document.name}</td>
                                                            <td className="">
                                                                <ul>
                                                                    <li className="user_setting float-end" style={{ listStyle: "none" }}>
                                                                        <div className="dropdown">
                                                                            <Link
                                                                                className="btn btn-secondary dropdown-toggle dn-1199 ms-2"
                                                                                role="button"
                                                                                to="#"
                                                                                id={"dropdownMenuLink" + document.id}
                                                                                data-bs-toggle="dropdown"
                                                                            >
                                                                                Actions <i className="fa fa-caret-down"></i>
                                                                            </Link>
                                                                            <ul
                                                                                className="dropdown-menu"
                                                                                aria-labelledby={"dropdownMenuLink" + document.id}
                                                                            >
                                                                                {profileMenuItems.map((actionMenuItem) => (
                                                                                    <li key={document.id + '-' + actionMenuItem.id}>
                                                                                        {actionMenuItem.onClick ? (
                                                                                            <Link
                                                                                                to="#"
                                                                                                className="dropdown-item"
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault(); // Prevent default anchor behavior
                                                                                                    actionMenuItem.onClick(document);
                                                                                                }}
                                                                                                style={
                                                                                                    isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                        ? { color: "#ff5a5f" }
                                                                                                        : undefined
                                                                                                }
                                                                                            >
                                                                                                <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                            </Link>
                                                                                        ) : (
                                                                                            <Link
                                                                                                to={actionMenuItem.routerPath + "/" + document.id} // Changed href to to
                                                                                                className="dropdown-item"
                                                                                                style={
                                                                                                    isSinglePageActive(`${actionMenuItem.routerPath}`, navigate.pathname)
                                                                                                        ? { color: "#ff5a5f" }
                                                                                                        : undefined
                                                                                                }
                                                                                            >
                                                                                                <i className={actionMenuItem.icon}></i>&nbsp;&nbsp;{actionMenuItem.name}
                                                                                            </Link>
                                                                                        )}
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </tr>
                                                    )) : (<tr><td colSpan="7" className="text-center"><em>No data available!</em></td></tr>)}
                                                </tbody>
                                            </table>
                                            {/* Delete Modal */}
                                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                                <Modal.Header closeButton style={{ backgroundColor: 'rgb(36, 50, 74)' }}>
                                                    <Modal.Title style={{ color: 'white' }}>Delete Document</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <p className="mb-4">
                                                        Are you sure you want to delete this document?
                                                    </p>
                                                </Modal.Body>
                                                <Modal.Footer style={{ borderTop: 'none' }}>
                                                    <Button variant="secondary" style={{ color: '#fff', backgroundColor: '#6c757d', border: 'none' }} onClick={handleCloseDeleteModal}>
                                                        Cancel
                                                    </Button>
                                                    <Button variant="danger" style={{ color: '#fff', backgroundColor: '#dc3545', border: 'none' }} onClick={handleRemoveDocument}>
                                                        Delete
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>

                                            {/* View Modal */}
                                            <Modal size="lg" show={showViewModal} onHide={handleCloseViewModal}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Document Details</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    {selectedRecord ? (
                                                        <div className="formView">
                                                            <p><strong>Code:</strong> {selectedRecord.documentCode ? selectedRecord.documentCode : "N/A"}</p>
                                                            <p><strong>Date Of Issuance:</strong> {isoToDate(selectedRecord.dateOfIssuance)}</p>
                                                            <p><strong>Date Of Expiry:</strong> {isoToDate(selectedRecord.dateOfExpiry)}</p>
                                                            <p><strong>Document Name:</strong> {selectedRecord.name}</p>
                                                            <p><strong>Description:</strong> {selectedRecord.description}</p>
                                                            <p>
                                                                <strong>Path:</strong>
                                                                &nbsp;
                                                                {selectedRecord.path ? (
                                                                    <a className="btn btn-primary" href={selectedRecord.path} target="_blank" rel="noopener noreferrer">
                                                                        <i className="icon-eye1" aria-hidden="true"></i> View Path
                                                                    </a>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </p>
                                                            
                                                        </div>
                                                    ) : (
                                                        <p>No record selected.</p>
                                                    )}

                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <Button variant="secondary" onClick={handleCloseViewModal}>
                                                        Close
                                                    </Button>
                                                </Modal.Footer>
                                            </Modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Row start */}
                {/* Row end */}
            </div>

        </>
    );
}

export default DocumentTable;